import React, { useState } from "react"
import { classDescriptions } from "../../../utils/classDescriptions"
import InfoBox from "../../ui/InfoBox"

export default function TaxonomyTree({ items, onSelectClass }: { items: any[]; onSelectClass: (node: any) => void }) {
  const [expanded, setExpanded] = useState<string | null>(null)
  const [selected, setSelected] = useState<string | null>(null)
  if (!items?.length) return null
  return (
    <ul className="mt-2 space-y-1 border-l border-slate-200 pl-2">
      {items.map(item => {
        const isExpanded = expanded === item.conceptId
        const hasChildren = Boolean(item.items?.length)
        return (
          <li key={item.conceptId}>
            <div className={`flex items-center gap-2 rounded-lg px-2 py-1.5 transition hover:bg-blue-50 ${selected === item.conceptId ? "bg-blue-50 text-blue-900" : "text-slate-700"}`}>
              <button type="button" className="flex min-w-0 flex-1 items-center gap-2 text-left text-sm" aria-expanded={hasChildren ? isExpanded : undefined} onClick={() => { setSelected(item.conceptId); setExpanded(isExpanded ? null : item.conceptId); onSelectClass(item) }}>
                <span className="w-3 shrink-0 text-xs text-slate-400">{hasChildren ? (isExpanded ? "▾" : "▸") : "·"}</span>
                <span className="min-w-0 break-words">{item.text}</span>
              </button>
              {item.level === 1 && item.classNumber && (
                <InfoBox title={`Class ${item.classNumber}`}><p>{classDescriptions[item.classNumber] || "No description available."}</p></InfoBox>
              )}
            </div>
            {isExpanded && hasChildren && <TaxonomyTree items={item.items} onSelectClass={onSelectClass} />}
          </li>
        )
      })}
    </ul>
  )
}
